.iconContainer {
  position: absolute;
  cursor: pointer;

  &:hover {
    transform: scale(1.25);
  }

  &.notClickable {
    cursor: default;

    &:hover {
      transform: none;
    }
  }
}
